export default () => ({
	isFilterOrSortOpen: false,
	currentDropdown: null as string | null,

	init() {
		this.updateActiveFilterCount()

		// Close on escape key
		document.addEventListener('keydown', (e: KeyboardEvent) => {
			if (e.key === 'Escape' && this.isFilterOrSortOpen) {
				this.closeDropdowns()
			}
		})

		// Close on click outside
		document.addEventListener('click', (e: MouseEvent) => {
			if (!this.isFilterOrSortOpen) return
			const target = e.target as HTMLElement
			if (!this.$el.contains(target)) {
				this.closeDropdowns()
			}
		})
	},

	toggleDropdown(type: string) {
		if (this.currentDropdown === type) {
			this.currentDropdown = null
			this.isFilterOrSortOpen = false
		} else {
			this.currentDropdown = type
			this.isFilterOrSortOpen = true
		}
	},

	closeDropdowns() {
		this.currentDropdown = null
		this.isFilterOrSortOpen = false
	},

	handleSortChange(value: string) {
		// Era sorting is client-side
		if (value === 'era-ascending' || value === 'era-descending') {
			this.sortByEra(value === 'era-ascending' ? 'asc' : 'desc')
			return
		}

		// Price sorting uses native Shopify sort_by
		const formData = new FormData()
		formData.append('sort_by', value)

		const filterForm = document.querySelector('#filter-form')
		if (filterForm) {
			filterForm
				.querySelectorAll<HTMLInputElement>('input[type="checkbox"]:checked')
				.forEach((checkbox) => {
					formData.append(checkbox.name, checkbox.value)
				})
		}

		const searchParams = new URLSearchParams(formData as any).toString()
		const url = `${window.location.pathname}${searchParams ? '?' + searchParams : ''}`

		window.location.href = url
	},

	sortByEra(direction: 'asc' | 'desc') {
		const grid = document.querySelector('[data-product-grid]')
		if (!grid) return

		const cards = Array.from(grid.querySelectorAll<HTMLElement>('[data-product-card]'))

		cards.sort((a, b) => {
			const eraA = parseInt(a.dataset.era || '0', 10)
			const eraB = parseInt(b.dataset.era || '0', 10)
			return direction === 'asc' ? eraA - eraB : eraB - eraA
		})

		// Reorder DOM elements
		cards.forEach((card) => grid.appendChild(card))
	},

	handleFilterChange() {
		const formData = new FormData()

		const sortForm = document.querySelector('#sort-form')
		if (sortForm) {
			const sortRadio = sortForm.querySelector<HTMLInputElement>(
				'input[name="sort_by"]:checked',
			)
			if (sortRadio && !sortRadio.value.startsWith('era')) {
				formData.append('sort_by', sortRadio.value)
			}
		}

		const filterForm = document.querySelector('#filter-form')
		if (filterForm) {
			const checkedBoxes = filterForm.querySelectorAll<HTMLInputElement>(
				'input[type="checkbox"]:checked',
			)
			checkedBoxes.forEach((checkbox) => {
				formData.append(checkbox.name, checkbox.value)
			})
		}

		const searchParams = new URLSearchParams(formData as any).toString()
		const url = `${window.location.pathname}${searchParams ? '?' + searchParams : ''}`

		window.location.href = url
	},

	updateActiveFilterCount() {
		const urlParams = new URLSearchParams(window.location.search)
		let count = 0

		urlParams.forEach((value, key) => {
			if (key === 'sort_by') {
				if (value === 'price-ascending' || value === 'price-descending') {
					count++
				}
				return
			}
			count++
		})

		this.$store.site.activeFilterCount = count
	},
})
